import { Roles, isAdminRole } from "@/services/repository/users"
import { Route } from "react-router-dom"
import { isNFCSupported, AccountantNFCWriterPage } from "./tools/nfc/accwriter"
import { Services } from "@/services/services"
import { CurrentSession } from "@/services/repository/session"
import { QRActivate } from './qr/Activate'
import { QRTag } from "./qr/Tag"

export const envRouting = ({ services, session } : { services: Services, session?: CurrentSession }) => {

  const forAnyone = () => {
    return <>
      <Route path='/qr/tag/:id' element={<QRTag />} />
      <Route path='/qr/activate/:id' element={<QRActivate />} />
      { isNFCSupported() ?<Route path='/tool/nfc/accountantwriter' element={<AccountantNFCWriterPage />} /> : null }
    </>
  }

  const forLoggedInUsers = () => {
    if (!session) {
      return
    }
    return <></>
  }

  const forSuperAdmin = () => {
    if (!session || !isAdminRole(session.user.role)) {
      return
    }
    return <></>
  }

  const forCompanyManager = () => {
    if (!session || session.user.role !== Roles.CompanyManager) {
      return
    }
    return <></>
  }

  const forServiceman = () => {
    if (!session || session.user.role !== Roles.Serviceman) {
      return
    }
    return <></>
  }

  return <>
    {forAnyone()}
    {forLoggedInUsers()}
    {forSuperAdmin()}
    {forServiceman()}
    {forCompanyManager()}
  </>
};
